import { useState, useEffect } from 'react';
import { useNavigate, useParams } from 'react-router-dom';
import { TextField, Button, CircularProgress, Snackbar, Alert } from '@mui/material';
import { doc, onSnapshot, updateDoc } from 'firebase/firestore';
import { db } from './firebaseConfig';
import './game.css';

const GuestPage = () => {
  const navigate = useNavigate();
  const [isTriviaOn, setIsTriviaOn] = useState(false);
  const { documentId } = useParams();
  const [loading, setLoading] = useState(true);
  const [name, setName] = useState('');
  const [nameSetInDb, setNameSetInDb] = useState(false);
  const [showSnackbar, setShowSnackbar] = useState(false);
  const [error, setError] = useState(null);
  // const [currentQuestion, setCurrentQuestion] = useState("");

  // useEffect(() => {
  //   const currentQuestionCollection = collection(db, 'currentQuestion');
  //   const currentQuestionQuery = query(currentQuestionCollection);
  //   const unsubscribe = onSnapshot(currentQuestionQuery, (snapshot) => {
  //     const updatedCurrentQuestion = snapshot.docs.map((doc) => ({
  //       id: doc.id,
  //       ...doc.data()
  //     }));
  //     setCurrentQuestion(updatedCurrentQuestion[0].id)
  //   });
  //   return () => unsubscribe();
  // }, [currentQuestion]);

  useEffect(() => {
    const unsub = onSnapshot(doc(db, "isTriviaOn", "s5y7fVw6BM5iOZs75VdM"), (doc) => {
      const data = doc.data();
      setIsTriviaOn(Boolean(data?.isOn))
    });
    return () => unsub();
  }, []);

  useEffect(() => {
    const fetchGuestData = async () => {
      try {
        const unsubscribe = onSnapshot(doc(db, "guest", documentId), (doc) => {
          const guestData = doc.data() || {};
          setName(guestData.name || '');
          if (guestData.name) {
            setNameSetInDb(true);
          }
          else {
            setNameSetInDb(false);

          }
          setLoading(false);
        });

        return unsubscribe;
        
      } catch (error) {
        console.error('Error fetching guest data:', error);
        setError('Failed to fetch guest data');
      }
    };

    let unsubscribe;
    fetchGuestData().then((cleanup) => {
      unsubscribe = cleanup;
    });
    return () => {
      if (unsubscribe) unsubscribe();
    };
  }, [documentId]);

  const handleSnackbarClose = () => {
    setShowSnackbar(false);
  };

  const handleSave = async (event) => {
    event.preventDefault(); // Prevents the default form submission behavior

    try {
      if (!name.trim()) {
        setError('Please enter your name before joining.');
        return;
      }
      setLoading(true);
      const updatedGuest = {
        name: name.trim(),
      };

      const guestDocRef = doc(db, 'guest', documentId);
      await updateDoc(guestDocRef, updatedGuest);

      setShowSnackbar(true);
      navigate(`/guest-questions/${documentId}`)
    } catch (error) {
      console.error('Error saving guest:', error);
      setError('Failed to save guest');
    } finally {
      setLoading(false);
    }
  };

  if (loading) {
    return <div className="game-shell"><div className="guest-page"><CircularProgress /></div></div>;
  }

  if (error) {
    return <div className="game-shell"><div className="guest-page"><div className="guest-name-card"><Alert severity="error">{error}</Alert><Button variant="contained" onClick={() => setError(null)}>Try Again</Button></div></div></div>;
  }

  return (
    <div className="game-shell">
    <div className="guest-page">
      <div className="guest-hero">
        <div className="party-sign party-sign-small">
          <span>Desi</span>
          <strong>50+</strong>
        </div>
        <div>
          <p className="game-kicker">Desi Couples Trivia Night</p>
          <h1 className="guest-title">Good Times, Great Company</h1>
        </div>
      </div>

      <form className="guest-name-card" onSubmit={handleSave}>
        <div className="guest-card-header">
          <span className="guest-pass-label">Party Pass</span>
          <span className="guest-pass-dots" aria-hidden="true"></span>
        </div>
        <h2>Enter your name</h2>
        <TextField
          label="Your Name"
          variant="outlined"
          value={name}
          onChange={(e) => setName(e.target.value)}
          inputProps={{ maxLength: 48 }}
          fullWidth
        />
        <div className="guest-actions">
          <Button className="party-primary-button" variant="contained" type="submit">
            {nameSetInDb ? "Save Name" : "Join the Party"}
          </Button>
        {
        isTriviaOn && nameSetInDb && <>
          <Button variant="outlined" onClick={() => { navigate(`/guest-questions/${documentId}`) }}>
            Go To Trivia
          </Button>
        </>
      }    
        </div>
        {
        !isTriviaOn && nameSetInDb && <>
          <div className="guest-waiting-note">You're checked in. Please wait for the host to start the next round.</div>
        </>
      }    
      </form>
      <Snackbar
        open={showSnackbar}
        autoHideDuration={10000}
        onClose={handleSnackbarClose}
        message="Save successful!"
        anchorOrigin={{ vertical: "top", horizontal: "center" }}
      >
        <Alert  onClose={handleSnackbarClose} severity="success" sx={{ width: '100%' }}>
          Save successful!
        </Alert>
      </Snackbar>
    </div>
    </div>
  );
};

export default GuestPage;

